/* import __COLOCATED_TEMPLATE__ from './ai-translation-settings.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type TeammateAiTranslationSettings from 'embercom/services/teammate-ai-translation-settings';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';

interface Args {
  isDisabled?: boolean;
  disabledTooltip?: string;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class AiTranslationSettings extends Component<Signature> {
  @service declare teammateAiTranslationSettings: TeammateAiTranslationSettings;

  get isInboxTranslationEnabled() {
    if (this.args.isDisabled) {
      return false;
    }
    return this.teammateAiTranslationSettings.isInboxTranslationEnabled;
  }

  get isMainToggleLoading() {
    return (
      taskFor(this.teammateAiTranslationSettings.toggleInboxTranslationConfiguration).isRunning ||
      taskFor(this.teammateAiTranslationSettings.fetchSettings).isRunning
    );
  }

  @action
  async toggleInboxTranslationConfiguration() {
    return taskFor(
      this.teammateAiTranslationSettings.toggleInboxTranslationConfiguration,
    ).perform();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::AccountSecurity::AiTranslationSettings': typeof AiTranslationSettings;
  }
}
